import dayjs from 'dayjs';
import { z } from 'zod';

export const date = z.string().refine(
  val => {
    return dayjs(val).isValid();
  },
  { message: 'Neplatné datum' }
);
